<template>
  <div class="levo__user__name">
    <div class="levo__user__name__email">
      <div class="levo__user__name__email__text">
        {{ me.username }}
        <div class="levo__user__name__options" @click="openModal()">
          <div class="levo__user__name__options--img"></div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div
      class="levo__user__name__team"
      v-if="me.team !== undefined && me.game !== undefined && me.game.active === true"
    >
      <div class="levo__user__name__team__text">Team: {{ me.team.name }}</div>
      <div class="clearfix"></div>
    </div>
    <ValidationObserver
      v-slot="{ handleSubmit, failed }"
      class="userModal"
      tag="div"
      ref="form"
    >
      <Modal ref="modalRef" topClass="yellow" width="720px" :closeFunction="userClose">
        <form @submit.prevent="handleSubmit(submitForm)">
          <div class="userModal__userInfo">
            <div class="userModal__userInfo__picture">
              <div class="userModal__userInfo__picture--img"></div>
            </div>
            <div class="userModal__userInfo__text">
              <div class="userModal__userInfo__text__team">{{ me.email }}</div>
              <div class="userModal__userInfo__text__signOut pointer" @click="signOut">
                Sign out
                <div class="userModal__userInfo__text__signOut__button">
                  <div class="userModal__userInfo__text__signOut__button--img"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="userModal__userInfoPlaceholder"></div>

          <div class="userModal__inputs">
            <div class="userModal__inputs__input-description">Username</div>
            <ValidationProvider
              v-if="isEditing"
              rules="required"
              v-slot="{ failedRules }"
            >
              <input
                type="text"
                class="userModal__inputs__input-nickname"
                placeholder="Username"
                v-model="nickname"
                disabled
              />
              <p class="validate-warn" v-if="failedRules.englishAlpha">
                {{ failedRules.englishAlpha }}
              </p>
            </ValidationProvider>
            <div class="userModal__inputs__input-description">New password</div>
            <ValidationProvider v-if="isEditing" rules="required" v-slot="{ failed }">
              <input
                type="password"
                class="userModal__inputs__input-password"
                placeholder="New password"
                :class="{ error: failed }"
                v-model="form.password"
              />
            </ValidationProvider>
            <div class="userModal__inputs__input-description">New password again</div>
            <ValidationProvider v-if="isEditing" rules="required" v-slot="{ failed }">
              <input
                type="password"
                class="userModal__inputs__input-password"
                placeholder="New password again"
                :class="{ error: failed }"
                v-model="form.confirmPassword"
              />
            </ValidationProvider>
          </div>

          <div class="userModal__button" :class="{ disabled: failed }">
            <button class="button">Save</button>
          </div>
        </form>
      </Modal>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "@/components/general/Modal.vue";
import ModalJs from "@/components/general/ModalJs.js";

export default {
  name: "UserDetails",
  mixins: [ModalJs],
  components: {
    Modal,
  },
  data: function () {
    const me = this.$store.state.userAccount.me;
    return {
      editMode: false,
      nickname: me.username,
      form: {
        password: "",
        checkPassword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      signOut: "signOut",
      changePassword: "changePassword",
    }),
    isEditing() {
      return this.editMode;
    },
    checkEmptyForm() {
      if (this.form.password == "" || this.form.confirmPassword == "") {
        this.$toast.error(this.$t("messages.user-account.change-password-empty-fields"));
        this.form.password = "";
        this.form.confirmPassword = "";
        return false;
      }
      return true;
    },
    checkPasswords() {
      if (this.form.password != this.form.confirmPassword) {
        this.$toast.error(
          this.$t("messages.user-account.change-password-different-passwords")
        );
        this.form.password = "";
        this.form.confirmPassword = "";
        return false;
      }
      return true;
    },
    async submitForm() {
      if (!this.checkEmptyForm() || !this.checkPasswords()) return false;

      await this.$store.dispatch("toggleLoader", true);

      try {
        await this.changePassword(this.form);
        this.$toast.success(this.$t("messages.user-account.change-password-success"));
        this.closeModal();
      } catch (e) {
        if (e.response.data.msg == "user-mng.pwd-policy-error") {
          this.$toast.error(this.$t("messages.user-account.change-password-pwd-policy"));
        } else if (e.response.data.msg == "user-mng.reset-pwd.pwd-no-change") {
          this.$toast.error(
            this.$t("messages.user-account.change-password-pwd-no-change")
          );
        } else {
          this.$toast.error(
            this.$t("messages.user-account.change-password-response", {
              msg: e,
            })
          );
          this.form.password = "";
          this.form.confirmPassword = "";
        }
      }
      await this.$store.dispatch("toggleLoader", false);
    },
    userClose: function () {
      this.form.password = "";
      this.form.confirmPassword = "";
    },
  },
  computed: {
    ...mapGetters({
      me: "me",
    }),
  },
};
</script>

<style></style>
